import { useState, useEffect } from 'react';

export const useAgreeSendingCardInfo = () => {
	// 同意文言チェックボックス処理
	const [isAgreeSendCardInfo, setIsAgreeSendCardInfo] = useState(false);
	const handleChangeAgreeCheckValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setIsAgreeSendCardInfo(event.target.checked);
	};

	return {
		isAgreeSendCardInfo,
		setIsAgreeSendCardInfo,
		handleChangeAgreeCheckValue,
	};
};
